import { apiClient } from './client';
import { API_CONFIG } from './config';

export type ProjectEntity = {
  projectId: string;
  code: string;
  userId?: string;
  name: string;
  description?: string;
  sector?: string;
  address?: string;
  email?: string;
  contactPerson?: string;
  contactNo?: string;
  country?: string;
  currency?: string;
  isTest: boolean;
  /** Disabled projects stay editable here but drop off the public booking site. */
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
};

/**
 * Role the backend seeds alongside a new project: a role access row, a user on
 * `<projectCode>.<role>@batamx.co`, and — when `booking` is granted — placeholder
 * service categories plus everyday booking hours.
 */
export type ProjectRoleSeed = {
  role: string;
  dashboard?: boolean;
  ecommerce?: boolean;
  user?: boolean;
  customer?: boolean;
  notification?: boolean;
  custom?: boolean;
  booking?: boolean;
  reward?: boolean;
  rental?: boolean;
  project?: boolean;
};

export type CreateProjectRequest = Partial<ProjectEntity> & { roles?: ProjectRoleSeed[] };

class ProjectApi {
  private ep = API_CONFIG.endpoints.projects;

  list() {
    return apiClient.get<ProjectEntity[]>(this.ep.list);
  }

  getById(id: string) {
    return apiClient.get<ProjectEntity>(this.ep.byId(id));
  }

  create(data: CreateProjectRequest) {
    return apiClient.post<ProjectEntity>(this.ep.create, data);
  }

  update(id: string, data: Partial<ProjectEntity>) {
    return apiClient.patch<ProjectEntity>(this.ep.update(id), data);
  }
}

export const projectApi = new ProjectApi();
